module.exports = __webpack_public_path__ + "static/media/banner-1.d5b6797a.jpeg";